import React, { useState } from 'react'
import moment from 'moment'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Method from './Method'
import SutureType from './SutureType'
import { Alert } from '@mui/material'
import TreatmentText from '../../TreatmentText'

const WoundClosure = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Wound Closure</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <Method moduleValues={moduleValues} setModuleValues={setModuleValues} />
        {moduleValues?.['Method'] === 'Sutures' && (
          <SutureType
            moduleValues={moduleValues}
            setModuleValues={setModuleValues}
          />
        )}
        {moduleValues?.['Method'] === 'Sutures' && (
          <Grid item={12}>
            <Alert severity="info">
              Remember to record drug administration (i.e. Lidocaine)
            </Alert>
          </Grid>
        )}
        <TreatmentText moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Wound Closure', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default WoundClosure
